module.exports = __webpack_public_path__ + "img/ico-youtube.f8d98391.svg";